module.exports = __webpack_public_path__ + "static/media/filter-empty-dark.c55b0e0d.svg";